import React from "react";
import { useSelector } from "react-redux";
import OnlyLoggedIn from "./OnlyLoggedIn";
import RemoveListItem from "./RemoveListItem";
import * as selectors from "../selectors";

export default ({ artId }) => {
  const userLoggedIn = useSelector(selectors.userLoggedIn);
  if (!userLoggedIn) return <OnlyLoggedIn />;
  const lists = useSelector(selectors.lists);
  const listsWithThis = lists.filter(
    list => list.artworks && list.artworks.includes(parseInt(artId, 10))
  );
  return (
    <>
      <p className="fav__heading fav__heading--add">
        Poista suosikkilistalta...
      </p>
      <div className="fav__lists">
        {!!listsWithThis.length &&
          listsWithThis.map(list => (
            <RemoveListItem key={list.id} list={list} artId={artId} />
          ))}
        {listsWithThis.length === 0 && (
          <p className="fav__list-none">
            Teos ei ole yhdelläkään suosikkilistallasi.
          </p>
        )}
      </div>
    </>
  );
};
